import { render, staticRenderFns } from "./NewMoneyTable.vue?vue&type=template&id=58bae748&scoped=true&"
import script from "./NewMoneyTable.vue?vue&type=script&lang=js&"
export * from "./NewMoneyTable.vue?vue&type=script&lang=js&"
import style0 from "./NewMoneyTable.vue?vue&type=style&index=0&id=58bae748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bae748",
  null
  
)

export default component.exports